import { useEffect } from 'react';
import * as THREE from 'three';
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader';

export default function FloorLogo({
    scene,
    svgPath,
    size = 300,
    y = 0,
    boardSizeRef,
    GRID_SIZE
}) {

    useEffect(() => {
        if (!scene) return;

        scene.children
            .filter(obj => obj.userData.isDecoration)
            .forEach(obj => {
                scene.remove(obj);
                obj.traverse((child) => {
                    if (child.geometry) child.geometry.dispose();
                    if (child.material) child.material.dispose();
                });
            });

        const loader = new SVGLoader();
        let group;

        loader.load(
            svgPath,
            (data) => {
                group = new THREE.Group();

                data.paths.forEach((path) => {
                    const shapes = SVGLoader.createShapes(path);
                    if (shapes.length === 0) return;

                    const fillColor = path.userData?.style?.fill;
                    const color = fillColor && fillColor !== 'none' ? new THREE.Color(fillColor) : new THREE.Color(0x1976d2);

                    const material = new THREE.MeshBasicMaterial({
                        color,
                        side: THREE.DoubleSide,
                        depthWrite: true,
                    });

                    shapes.forEach((shape) => {
                        const geometry = new THREE.ShapeGeometry(shape);
                        const mesh = new THREE.Mesh(geometry, material);
                        group.add(mesh);
                    });
                });

                if (group.children.length === 0) return;

                group.rotation.x = Math.PI / 2;
                group.rotation.z = Math.PI / 2;

                const box = new THREE.Box3().setFromObject(group);
                const maxDim = Math.max(box.getSize(new THREE.Vector3()).x, box.getSize(new THREE.Vector3()).z);
                const scale = size / maxDim;
                group.scale.setScalar(scale);

                box.setFromObject(group);
                const center = new THREE.Vector3();
                box.getCenter(center);
                group.position.sub(center);

                const { dimX, dimZ } = boardSizeRef;
                const centerX = 0;
                const centerZ = -((dimZ - 1) / 2) * GRID_SIZE - 25;
                group.position.x += centerX;
                group.position.z += centerZ;

                group.position.y = y;


                group.userData.isDecoration = true;
                scene.add(group);
            },
            undefined,
            (err) => console.error('SVG load error:', err)
        );

        return () => {
            if (group) scene.remove(group);
        };
    }, [scene, svgPath, size, y, boardSizeRef, GRID_SIZE]);

    return null;
}



// import { useEffect } from 'react';
// import * as THREE from 'three';
// import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader';

// export default function FloorLogo({
//     scene,
//     svgPath,
//     size = 300,
//     y = 5,
//     boardSizeRef,
//     GRID_SIZE
// }) {

//     console.log('boardSizeRef', boardSizeRef)
//     useEffect(() => {
//         if (!scene) return;

//         scene.children
//             .filter(obj => obj.userData.isDecoration)
//             .forEach(obj => {
//                 scene.remove(obj);
//                 obj.traverse((child) => {
//                     if (child.geometry) child.geometry.dispose();
//                     if (child.material) child.material.dispose();
//                 });
//             });

//         const loader = new SVGLoader();
//         let group;

//         loader.load(
//             svgPath,
//             (data) => {
//                 group = new THREE.Group();

//                 data.paths.forEach((path, i) => {
//                     const shapes = SVGLoader.createShapes(path);
//                     console.log(`Path ${i} shapes:`, shapes.length);

//                     if (shapes.length === 0) return;

//                     const fillColor = path.userData?.style?.fill;
//                     const color = fillColor && fillColor !== 'none' ? new THREE.Color(fillColor) : new THREE.Color(0x1976d2);

//                     const material = new THREE.MeshBasicMaterial({
//                         color,
//                         side: THREE.DoubleSide,
//                         depthWrite: true,
//                     });

//                     shapes.forEach((shape) => {
//                         const geometry = new THREE.ShapeGeometry(shape);
//                         const mesh = new THREE.Mesh(geometry, material);
//                         group.add(mesh);
//                     });
//                 });

//                 if (group.children.length === 0) {
//                     console.warn('FloorLogo: brak widocznych kształtów w SVG!');
//                     return;
//                 }

//                 group.rotation.x = -Math.PI / -2;

//                 const box = new THREE.Box3().setFromObject(group);
//                 const maxDim = Math.max(
//                     box.getSize(new THREE.Vector3()).x,
//                     box.getSize(new THREE.Vector3()).z
//                 );
//                 const scale = size / maxDim;
//                 group.scale.setScalar(scale);

//                 box.setFromObject(group);
//                 const center = new THREE.Vector3();
//                 box.getCenter(center);
//                 group.position.sub(center);
//                 group.position.y = y - 5;
//                 group.position.z = (boardSizeRef.dimZ * GRID_SIZE) / 2 - GRID_SIZE / 2;



//                 group.userData.isDecoration = true;
//                 scene.add(group);

//                 console.log('SVG dodany na scenę:', svgPath, group);
//             },
//             undefined,
//             (err) => console.error('SVG load error:', err)
//         );

//         return () => {
//             if (group) scene.remove(group);
//         };
//     }, [scene, svgPath, size, y]);

//     return null;
// }
